__turbopack_context__.v({
  "className": "bg-YtW_className",
  "variable": "bg-YtW_variable",
});
